<template>
    <b-modal
        id="paper-powerpoint-upload-modal"
        ref="paper-powerpoint-upload-modal"
        :title="$t('common.upload')"
        :ok-title="$t('common.upload')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-disabled="disabled"
        modal-class="apprentice-default-modal"
        @close="onClose()"
        @ok="onOk()">
        <div class="error">
            <b-alert
                show
                variant="danger">
                {{
                    $t(
                        'group.internship.make_sure_no_one_is_working_in_the_editor_if_a_file_is_uploaded_while_someone_is_in_the_editor_work_may_be_lost',
                    )
                }}
            </b-alert>
        </div>

        <div class="file-upload">
            <form
                :action="this.routes.groupUploadPowerpointBlueprint(id)"
                ref="form"
                method="post"
                enctype="multipart/form-data">
                <b-form-file
                    class="apprentice-file-upload"
                    v-model="file"
                    name="file"
                    :placeholder="$t('group.internship.choose_file')"
                    :drop-placeholder="$t('group.internship.place_file_here')"
                    :browse-text="$t('group.internship.choose_file')">
                </b-form-file>

                <input
                    type="hidden"
                    name="_token"
                    :value="csrfToken" />
            </form>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'group-show-upload-powerpoint-blueprint-modal-component',
    props: ['id'],
    data() {
        return {
            file: null,
        };
    },
    methods: {
        onOk() {
            this.$refs.form.submit();
            this.alert.saving(
                'Uploaden',
                this.$t('group.internship.the_file_is_being_uploaded_please_wait_one_moment'),
            );
        },
        onClose() {
            this.file = null;
        },
    },
    computed: {
        disabled() {
            return !this.file;
        },
    },
    created() {
        this.csrfToken = document.querySelector('meta[name="csrf-token"]').content;
    },
};
</script>

<style scoped lang="scss">
.error {
    margin-top: 0;
}

.file-upload {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}
</style>
